enum BackgroundColorClusterTag {
  TEAL_10 = '#E0F9F7',
  YELLOW_10 = '#FFF3DD',
  ORANGE_10 = '#FFF1ED'
}

enum NameColorClusterTag {
  TEAL_70 = '#165C56',
  YELLOW_60 = '#9A6412',
  ORANGE_60 = '#C1462B'
}

export const CLUSTER_TAG_COLORS = [
  {
    nameColor: NameColorClusterTag.TEAL_70,
    backgroundColor: BackgroundColorClusterTag.TEAL_10
  },
  {
    nameColor: NameColorClusterTag.YELLOW_60,
    backgroundColor: BackgroundColorClusterTag.YELLOW_10
  },
  {
    nameColor: NameColorClusterTag.ORANGE_60,
    backgroundColor: BackgroundColorClusterTag.ORANGE_10
  }
];

export enum ClusterEventType {
  Created = 'Cluster Created',
  Edited = 'Cluster Edited',
  Deleted = 'Cluster Deleted',
  Clicked = 'Cluster Tag Clicked'
}
